import VisualizationService from "@configuratorware/configurator-frontendgui/App/Services/VisualizationService";
import { getConf } from "@configuratorware/configurator-frontendgui/App/configuration";
import { createAdapterConfig } from "redhotmagma-visualization/visualizationAdapterCreator";
import { NoVisualization } from "@configuratorware/configurator-frontendgui/App/Screens/Configurator/Components/NoVisualization/NoVisualization";
import { CustomThree2DLayers } from "../Components/CustomThree2DLayers/CustomThree2DLayers";
import { CustomThree2D } from "../Components/CustomThree2D/CustomThree2D";

export default class CustomVisualizationService extends VisualizationService {
  adapterConfig = createAdapterConfig(
    { host: getConf("network.host") },
    {
      default: {
        Component: NoVisualization,
      },
      '2dLayer': {
        adapterClass: CustomThree2DLayers,
      },
      '2dVariant' : {
        adapterClass: CustomThree2D,
      },
    }
  );
  enableUserMovement() {
    // to let camera be locked
  }
}
